/** Package hero pixel dimensions, shared with the offline portrait renderer. */
export const HERO_SIZE = 1024;
